import React from 'react';
import { Link } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';
import AdminProspectResponseNotificationsBell from '../AdminProspectResponseNotificationsBell';

export default function AdminHeader({ email, role, onRefreshRole }) {
  const { t } = useLanguage();
  return (
    <header className="flex items-center gap-2 border-b border-slate-200 bg-white px-3 py-3 sm:gap-3 sm:px-4">
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-slate-900">{t('admin.shell.title')}</p>
        <p className="truncate text-xs text-slate-500">
          {email || '—'} · {role || t('admin.shell.legacyRole')}
        </p>
      </div>
      <AdminProspectResponseNotificationsBell role={role} />
      {onRefreshRole ? (
        <button
          type="button"
          onClick={onRefreshRole}
          className="inline-flex h-9 shrink-0 items-center justify-center gap-1 rounded-lg border border-slate-200 px-2 text-xs text-slate-600 hover:bg-slate-50 sm:h-auto sm:px-2 sm:py-1"
          title={t('admin.shell.refreshRole')}
          aria-label={t('admin.shell.refreshRole')}
        >
          <RefreshCw className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">{t('admin.shell.refreshRole')}</span>
        </button>
      ) : null}
      <Link
        to="/"
        className="shrink-0 whitespace-nowrap text-xs font-medium text-indigo-600 hover:underline"
      >
        {t('admin.shell.backToApp')}
      </Link>
    </header>
  );
}
